module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNGf9256286f04e49c1617057ceb12b7ff6.f9256286.png";